// extracted by mini-css-extract-plugin
module.exports = {"errors":"RCRange-module__errors___14qt8","extra":"RCRange-module__extra___3DYEQ","value":"RCRange-module__value___34exD","valueSmall":"RCRange-module__valueSmall___1cOj9"};